export default{
  productToEdit: {
    product_id: null,
    product_name: '',
    product_owner_name: '',
    product_is_active: true,
    product_updated_at: ''
  },
  loading: true,
  loadingClear: false,
  page: 0,
  currentPage: 1,
  size: 100,
  pagination: {
    current_page: 0,
    number_of_elements: 0,
    total_elements: 0,
    total_pages: 0
  },
  is_active: null,
  items: []
}


// WEBPACK FOOTER //
// ./src/store/modules/product/state.js